<template>
    <b-modal id="modal_form"
             ref="modal_form"
             :title="modal_titulo"
             :ok-title="modal_botao"
             close-title="Fechar"
             cancel-title="Cancelar"
             :ok-disabled=form.errors.any()
             v-model="showModal"
             @ok="handleOk">
             <form @submit.stop.prevent="handleOk" @keydown="form.errors.clear($event.target.name)">
                 <label>Nome do UF</label>
                 <b-form-input type="text"
                               placeholder="Nome do UF"
                               v-model="form.nome"
                               name="nome"
                               >
                 </b-form-input>
                 <b-form-feedback class="text-danger" v-text="form.errors.get('nome')" v-if="form.errors.has('nome')"></b-form-feedback>

                 <label>Código</label>
                 <b-form-input type="text"
                               placeholder="Código"
                               v-model="form.cd"
                               name="cd"
                               >
                 </b-form-input>
                 <b-form-feedback class="text-danger" v-text="form.errors.get('cd')" v-if="form.errors.has('cd')"></b-form-feedback>
                 <b-form-feedback class="text-danger" v-text="form.errors.get('cd')" v-if="form.errors.has('cd')"></b-form-feedback>

                 <label>Código IBGE</label>
                 <b-form-input type="text"
                               placeholder="Código IBGE"
                               v-model="form.cd_ibge"
                               name="cd_ibge"
                               >
                 </b-form-input>
                 <b-form-feedback class="text-danger" v-text="form.errors.get('cd_ibge')" v-if="form.errors.has('cd_ibge')"></b-form-feedback>

                 <label>Código ERP</label>
                 <b-form-input type="text"
                               placeholder="Código ERP"
                               v-model="form.cd_opentech"
                               name="cd_opentech"
                               >
                 </b-form-input>
                 <b-form-feedback class="text-danger" v-text="form.errors.get('cd_opentech')" v-if="form.errors.has('cd_opentech')"></b-form-feedback>


                 <label>País</label>
                 <multiselect v-model="paisSelected"
                 :options="optionsListItemPais"
                 track-by="value"
                 label="label"
                 :hide-selected="true"
                 placeholder="Selecione"
                 tag-placeholder="Selecionar"
                 select-label="Selecionar"
                 selected-label="Selecionado"
                 deselect-label="Remover"
                 ></multiselect>
                 <b-form-feedback class="text-danger" v-text="form.errors.get('pais_id')" v-if="form.errors.has('pais_id')"></b-form-feedback>

                 <label>Status</label>
                 <b-form-group>
                   <b-form-radio-group
                     v-model="form.status"
                     :options="optionsLivStatus"
                     name="status"
                     stacked
                     plain
                   ></b-form-radio-group>
                 </b-form-group>
                 <b-form-feedback v-text="form.errors.get('status')"  v-if="form.errors.has('status')"></b-form-feedback>

          </form>
          <div slot="modal-footer" class="w-100">
                 <div class="float-left"><spinner v-if="loading" message="Processando..."></spinner></div>
                 <div class="float-right">
                     <AvisoErros v-bind:errors_array="errors_array"></AvisoErros>
                     <b-btn @click="showModal=false" variant="secondary">
                       Fechar
                     </b-btn>
                     <b-btn @click="handleOk($event)" variant="secondary" :disabled="isDisabled">
                       Enviar
                     </b-btn>
                 </div>
          </div>
      </b-modal>
</template>
<script>
import AvisoErros from '../components/AvisoErros'

export default {
components: {
    AvisoErros,
},
props: {
    metodo: {type: Function},
    tabela: '',
    rota: ''
},
data () {
    return {
      dataExport: [],
      modal_titulo: '',
      modal_botao: '',
      modal_acao: '',
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      isFullscreen: false,
      paisSelected: [],
      optionsLivStatus: [],
      optionsListItemPais: [],
      errors_array: [],
      form: new Form({
          cd: '',
          nome: '',
          cd_ibge: '',
          cd_opentech: '',
          pais_id: '',
          status: 1
                   }),
     helpForm: new Form({statusRecord: [], params: []}),
    fields: [
      {
          name: '__checkbox',
          titleClass: 'center aligned',
          dataClass: 'center aligned'
      },
      {
        name: 'cd',
        title: 'Código',
        sortField: 'cd'
      },
      {
        name: 'descr',
        title: 'Descrição',
        sortField: 'descr'
      },
      {
        name: '__slot:status',
        title: 'Status',
        sortField: 'status'
      },
      {
          name: '__slot:actions',   // <----
          title: 'Ações',
          titleClass: 'center aligned',
          dataClass: 'center aligned'
      }
  ],
  css: {
      loadingClass: 'loading',
      ascendingIcon: 'glyphicon glyphicon-chevron-up',
      descendingIcon: 'glyphicon glyphicon-chevron-down',
      handleIcon: 'glyphicon glyphicon-menu-hamburger',
  },
  moreParams: {}
   }
},
watch: {
    paisSelected(obj) {
        this.form.pais_id = obj.value;
    }
},
mounted() {
    this.getLivGeral();
  },
methods: {
    handleOk(e)
    {
        e.preventDefault();
        if(this.modal_acao=="i")
        {
           this.onStore();
        }
        else
        {
            this.onUpdate(this.form.uf_id);
        }
    },
    onCreate ()
    {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Cadastrar";
      this.modal_botao = "Cadastrar";
      this.modal_acao = "i";
      this.form.reset();
      this.errors_array = '';
      this.errors_array = [];
      this.paisSelected = [];
      this.form.status = 1;
      this.$refs.modal_form.show();
    },
    onEdit (data, index, id)
    {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Alterar";
      this.modal_botao = "Alterar";
      this.modal_acao = "u";
      this.form.reset();
      this.errors_array = '';
      this.errors_array = [];
      this.paisSelected = [];
      this.form.cd = data.cd;
      this.form.nome = data.nome;
      this.form.cd_ibge = data.cd_ibge;
      this.form.cd_opentech = data.cd_opentech;
      this.paisSelected = {label: data.pais.nome, value: data.pais.pais_id};
      this.form.status = data.status.valor;
      this.form.uf_id = id;
      this.$refs.modal_form.show();
    },
    onStore()
    {
        this.loading = true;
        this.isDisabled = true;
        this.form.put('/api/'+this.rota+'/store').then(response =>
        {
            new ReturnApi(response, this)
            if(this.metodo!=null)
            {
               this.metodo();
            }
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = '';
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof(errors[property]) === 'object') {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj
                    });
                  });
                }
              }
            }
        });
    },
    onUpdate(id)
    {
        this.loading = true;
        this.isDisabled = true;
        this.form.patch('/api/'+this.rota+'/update/'+id).then(response =>
        {
            new ReturnApi(response, this)
            if(this.metodo!=null)
            {
               this.metodo();
            }
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = '';
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof(errors[property]) === 'object') {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj
                    });
                  });
                }
              }
            }
        });
    },
    onActivateDesactivate(helpForm)
    {
        helpForm.patch('/api/'+this.rota+'/status').then(response =>
        {
            new ReturnApi(response, this)
            if(this.metodo!=null)
            {
               this.metodo();
            }
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = '';
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof(errors[property]) === 'object') {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj
                    });
                  });
                }
              }
            }
        });

    },
    getLivGeral()
    {
        this.helpForm.get('/api/uf/jsonlistgeral').then(response =>
        {
            new ReturnApi(response, this, true, false, false);
            response.status.forEach((obj)=>
            {
                this.optionsLivStatus.push({ text: obj.descr, value: obj.valor })
            })
            response.pais.forEach((obj)=>
            {
                this.optionsListItemPais.push({ label: obj.nome, value: obj.pais_id })
            })
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = '';
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof(errors[property]) === 'object') {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj
                    });
                  });
                }
              }
            }
        });
    },
    onError(response) {
        new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
        return this.getPermissionFw(checkPermission);
    },
},
computed: {
    vuetableFilterRow: {
      get () {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
        get() {
            return this.$store.getters.isloaded;
        }
    }
}
}
</script>
